import { render } from "./ChangeVatView.vue?vue&type=template&id=5e611da1"
import script from "./ChangeVatView.vue?vue&type=script&lang=js"
export * from "./ChangeVatView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__